import { useDispatch } from "react-redux";
import { prof_routes } from "../../../feature-module/router/all_routes";
import { setMobileSidebar } from "../../data/redux/sidebarSlice";
import { Link } from "react-router-dom";

const TeacherIconMenu = () => {
  const routes = prof_routes;

  const dispatch = useDispatch();

  return (
    <>
      <div className="col-6 col-md-4 mb-3">
        <Link
          to={routes.teacherEDT}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
              <i className="ti ti-calendar" />
            </span>
          </div>
          <p className="text-dark">EDT</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-3">
        <Link
          to={routes.teacherCourse}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-secondary-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-secondary rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-secondary rounded-circle">
              <i className="ti ti-license" />
            </span>
          </div>
          <p className="text-dark">Mes Cours</p>
        </Link>
      </div>
    </>
  );
};

export default TeacherIconMenu;
